import { CommonModule } from '@angular/common';
import { Component, HostListener, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { AccountFilterComponent } from "../../_shared/components/filters/account-filter/account-filter.component";
import { isEmptyObject } from '../../_shared/helpers/object.helper';
import { AccountFilterData, DateIntervalFilterData } from '../../_shared/models';
import { FilterService } from '../../_shared/services';
import { DriverInformationListService } from '../driver-information/services/driver-information-list.service';

@Component({
  selector: 'app-driver-search-filter',
  standalone: true,
  imports: [CommonModule, AccountFilterComponent, ReactiveFormsModule, TranslocoPipe],
  templateUrl: './driver-search-filter.component.html',
  styleUrl: './driver-search-filter.component.scss',
})
export class DriverSearchFilterComponent implements OnInit, OnDestroy {
  @Input() disabled: boolean = false;

  public accountFilter: AccountFilterData = {} as AccountFilterData;
  public dateFilter: DateIntervalFilterData = {} as DateIntervalFilterData;
  public searchControl = new FormControl('');
  private searchSubscription: Subscription;
  private filterService = inject(FilterService);
  private driverListService = inject(DriverInformationListService);

  ngOnInit(): void {
    this.subscribeToSearch();
  }

  private subscribeToSearch(): void {
    this.searchSubscription = this.searchControl.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe(searchTerm => {
        // Send search term to service
        this.driverListService.updateSearchTerm(searchTerm || '');
      });
  }

  onAccountFilterChange(filterData: AccountFilterData) {
    this.accountFilter = filterData;
    if (!isEmptyObject(this.accountFilter)) {
      this.filterService.updateFilter({
        ...this.filterService.filter,
        ...this.accountFilter
      });
    }
  }

  public companies = [
    'Company 1',
    'Company 2',
    'Company 3',
    'Company 4',
    'Company 5',
    'Company 6',
    'Company 7',
    'Company 8',
    'Company 9',
    'Company 10',
  ];

  public locations = [
    'Location 1',
    'Location 2',
    'Location 3',
    'Location 4',
    'Location 5',
    'Location 6',
    'Location 7',
    'Location 8',
    'Location 9',
    'Location 10',
  ];

  public vehicles = [
    'Vehicle 1',
    'Vehicle 2',
    'Vehicle 3',
    'Vehicle 4',
    'Vehicle 5',
  ];

  public drivers = [
    'Driver 1',
    'Driver 2',
    'Driver 3',
    'Driver 4',
    'Driver 5'
  ];

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.closest('.dropdown-menu .nav-link , .dropdown-menu label')) {
      event.stopPropagation();
    }
  }

  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe();
  }
}